// Copyright © Veeam Software Group GmbH

import type { TeamsItem, TeamsItemType } from 'services/models/Teams/TeamsItem';

export const checkItemsType = (items: TeamsItem[]): TeamsItemType => items[0].itemType;
